define(["dojo/i18n", "/mathworks/devel/bat/filer/batfs1301-0/Cdoctools2p.2370998/build/scm/development-docsurvey/0.3.0/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/mathworks/devel/bat/filer/batfs1301-0/Cdoctools2p.2370998/build/scm/development-docsurvey/0.3.0/target/debug/2P/derived/ui/mw-rating/nls/main.js?absMid=mw-rating/nls/main"
], function(loader, runner) {
   return runner(loader, "mw-rating/nls/main", __webpack_require__.dj.c(), true);
});